/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return */
import Immutable from 'immutable'
import { useMemo } from 'react'

export default function useForceImmutable(value: unknown): any {
  const immutableValue = useMemo<any>(
    () => (Immutable.Iterable.isIterable(value) ? value : Immutable.fromJS(value)),
    [value]
  )
  return immutableValue
}
